import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { agentOfficeSetupService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseGenerateAgentOfficeApiMutationProps = {
	onSuccess?: Function;
	onError?: Function;
};

const useGenerateAgentOfficeApiMutation = ({
	onSuccess,
	onError,
}: UseGenerateAgentOfficeApiMutationProps = {}) => {
	const dispatch = useDispatch();

	return useMutation(
		({ companyId }: { companyId: string }) => {
			return agentOfficeSetupService.generateAgentOfficeApi({
				companyId,
			});
		},
		{
			onSuccess(result) {
				onSuccess?.(result);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);

				onError?.(error);
			},
		},
	);
};

export default useGenerateAgentOfficeApiMutation;
